import { useAssignmentUpdateAssignment } from 'api/assignment/assignment';
import { AssignmentModel, CaseModel } from 'api/model';
import TextButton from 'components/inputs/TextButton';
import toast from 'react-hot-toast';

const TrimBreakTimeButton: React.FC<{
  assignment: AssignmentModel;
  caseModel: CaseModel;
  minBreakMinutes: number;
  onUpdate?: () => void;
}> = ({ assignment, caseModel, minBreakMinutes, onUpdate }) => {
  const updateAssignmentCall = useAssignmentUpdateAssignment();

  const trim = async () => {
    try {
      await updateAssignmentCall.mutateAsync({
        data: {
          assignment: { ...assignment, breakTime: minBreakMinutes },
          case: caseModel,
        },
      });
      toast.success(`Rast trimmad till ${minBreakMinutes} min`);
      onUpdate?.();
    } catch (error) {
      toast.error('Kunde inte trimma rasten');
    }
  };

  return (
    <TextButton
      onClick={trim}
      disabled={updateAssignmentCall.isLoading}
      style={{ justifySelf: 'start', paddingLeft: 0 }}
    >
      Trimma rast till {minBreakMinutes} min
      {updateAssignmentCall.isLoading && '...'}
    </TextButton>
  );
};

export default TrimBreakTimeButton;
